
export class ValidatorHelper {
    constructor() {}

    static setCustomComponentValidation(element: HTMLInputElement, errorMessage: string) {
        var customErrorMsgControl = element.parentElement.parentElement.parentElement.getElementsByClassName("invalid-feedback")[0];

        this.setCustomValidationWithFeedback(element, errorMessage, customErrorMsgControl);
    }

    static setCustomValidationWithFeedback(element: HTMLInputElement, errorMessage: string, customErrorMsgControl?: Element) {
        if (!element) return;

        element.parentElement.parentElement.classList.add('is-invalid');
        element.setCustomValidity(errorMessage);

        var errorMsgControl = customErrorMsgControl ? customErrorMsgControl : element.parentElement.getElementsByClassName("invalid-feedback")[0];

        if (!errorMsgControl) return;

        errorMsgControl.textContent = errorMessage;
    }

    static clearCustomComponentValidation(element: HTMLInputElement) {

        var customErrorMsgControl = element.parentElement.getElementsByClassName("invalid-feedback")[0];

        this.clearCustomValidation(element, customErrorMsgControl);
    }

    static clearCustomValidation(element: HTMLInputElement, customErrorMsgControl? : Element) {
        if (!element) return;

        element.parentElement.parentElement.classList.remove('is-invalid');
        element.setCustomValidity("");

        var errorMsgControl = customErrorMsgControl ? customErrorMsgControl : element.parentElement.getElementsByClassName("invalid-feedback")[0];
        if (!errorMsgControl) return;

        errorMsgControl.textContent = null;
    }
}